// Menu
document.addEventListener('DOMContentLoaded', function () {
	const toggle = document.querySelector('.menu-toggle');
	const navWrapper = document.querySelector('.nav-menu-wrapper');

	if (toggle && navWrapper) {
		toggle.addEventListener('click', () => {
			navWrapper.classList.toggle('active');
		});
	}

	document.querySelectorAll('.menu-item-has-children > a').forEach(link => {
		link.addEventListener('click', function (e) {
			if (window.innerWidth <= 991) {
				e.preventDefault();
				this.parentElement.classList.toggle('active');
			}
		});
	});
});

// Slider-block
jQuery(document).ready(function ($) {
	$('.slider').slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 3000,
		prevArrow: '<button type="button" class="slick-prev">‹</button>',
		nextArrow: '<button type="button" class="slick-next">›</button>',
		responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2
				}
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1
				}
			}
		]
	});

	// Testimonials Slider
	$('.testimonials-slider').each(function() {
		const $slider = $(this);
		const autoplay = $slider.data('autoplay') === true || $slider.data('autoplay') === 'true';
		const speed = parseInt($slider.data('speed')) || 3000;

		$slider.slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: autoplay,
			autoplaySpeed: speed,
			dots: true,
			prevArrow: '<button type="button" class="slick-prev">‹</button>',
			nextArrow: '<button type="button" class="slick-next">›</button>'
		});
	});
});

// Counter-block
document.addEventListener("DOMContentLoaded", function () {
	const counters = document.querySelectorAll(".counter");

	counters.forEach(counter => {
		const target = +counter.getAttribute("data-target");
		let count = 0;
		const duration = 2000;
		const steps = 100;
		const increment = Math.ceil(target / steps);
		const intervalTime = duration / steps;

		const formatNumber = (num) => {
			return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '\u00A0'); // espace insécable
		};

		const interval = setInterval(() => {
			count += increment;
			if (count >= target) {
				count = target;
				clearInterval(interval);
			}
			counter.innerText = formatNumber(count);
		}, intervalTime);
	});

	// Statistics counter animation (for front-page)
	const statNumbers = document.querySelectorAll('.stat-number[data-count]');
	
	const animateCounter = (element) => {
		const target = parseInt(element.getAttribute('data-count'), 10);
		const duration = 2000;
		const steps = 60;
		const increment = target / steps;
		let current = 0;
		
		const formatNumber = (num) => {
			return Math.floor(num).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '\u00A0');
		};
		
		const timer = setInterval(() => {
			current += increment;
			if (current >= target) {
				current = target;
				clearInterval(timer);
			}
			element.textContent = formatNumber(current);
		}, duration / steps);
	};

	// Intersection Observer for counter animation
	if (statNumbers.length > 0) {
		const observer = new IntersectionObserver((entries) => {
			entries.forEach(entry => {
				if (entry.isIntersecting && !entry.target.classList.contains('counted')) {
					entry.target.classList.add('counted');
					animateCounter(entry.target);
				}
			});
		}, { threshold: 0.5 });

		statNumbers.forEach(stat => {
			observer.observe(stat);
		});
	}
});

// AOS
document.addEventListener("DOMContentLoaded", function () {
	const elements = document.querySelectorAll('.has-gimmicks-left');

	elements.forEach(function (element) {
		element.setAttribute('data-aos', 'fade-right');
	});
	AOS.init({
		duration: 1200,
		easing: 'ease-in-out',
		once: true
	});
});

// Submenu

// Copy link buttons
document.addEventListener('click', (event) => {
	const button = event.target.closest('.copy-link');
	if (!button) {
		return;
	}
	event.preventDefault();
	const link = button.getAttribute('data-link');
	if (!link) {
		return;
	}
	navigator.clipboard.writeText(link).then(() => {
		button.classList.add('copied');
		setTimeout(() => button.classList.remove('copied'), 2000);
	});
});

// Share trigger in article header
document.addEventListener('click', (event) => {
	const shareTrigger = event.target.closest('.lpm-article__share-trigger');
	if (!shareTrigger) {
		return;
	}
	event.preventDefault();
	const sidebar = document.querySelector('.lpm-article__share');
	if (sidebar) {
		sidebar.scrollIntoView({ behavior: 'smooth', block: 'start' });
		// Highlight the share section briefly
		sidebar.style.transition = 'background-color 0.3s ease';
		sidebar.style.backgroundColor = 'rgba(0, 61, 165, 0.05)';
		setTimeout(() => {
			sidebar.style.backgroundColor = '';
		}, 1000);
	}
});

// Reading progress bar
document.addEventListener('DOMContentLoaded', function () {
	const progressBar = document.querySelector('.lpm-reading-progress');
	if (progressBar) {
		const article = document.querySelector('.lpm-article');
		if (article) {
			const updateProgress = () => {
				const windowHeight = window.innerHeight;
				const documentHeight = document.documentElement.scrollHeight;
				const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
				const articleTop = article.offsetTop;
				const articleHeight = article.offsetHeight;
				const articleBottom = articleTop + articleHeight;
				
				// Calculer la progression dans l'article
				const scrollBottom = scrollTop + windowHeight;
				const articleVisibleTop = Math.max(scrollTop, articleTop);
				const articleVisibleBottom = Math.min(scrollBottom, articleBottom);
				const articleVisibleHeight = Math.max(0, articleVisibleBottom - articleVisibleTop);
				const articleProgress = articleVisibleHeight / articleHeight;
				
				// Calculer la progression totale du scroll dans l'article
				const scrollProgress = Math.max(0, Math.min(1, (scrollTop - articleTop) / articleHeight));
				const totalProgress = Math.max(0, Math.min(1, scrollProgress + articleProgress));
				
				progressBar.style.width = (totalProgress * 100) + '%';
			};
			
			window.addEventListener('scroll', updateProgress);
			window.addEventListener('resize', updateProgress);
			updateProgress(); // Initial call
		}
	}
});

// Table des matières avec animation d'avancement
document.addEventListener('DOMContentLoaded', function () {
	const tocLinks = document.querySelectorAll('.lpm-article__toc a[data-section]');
	const sections = [];

	if (tocLinks.length > 0) {
		// Récupérer toutes les sections
		tocLinks.forEach(link => {
			const sectionId = link.getAttribute('data-section');
			const section = document.getElementById(sectionId);
			if (section) {
				sections.push({
					id: sectionId,
					element: section,
					link: link,
					li: link.closest('li')
				});
			}
		});

		// Fonction pour mettre à jour l'état actif
		const updateActiveSection = () => {
			const scrollPosition = window.pageYOffset + 150; // Offset pour le header

			// Trouver la section actuellement visible
			let activeSection = null;
			for (let i = sections.length - 1; i >= 0; i--) {
				const section = sections[i];
				const sectionTop = section.element.offsetTop;
				if (scrollPosition >= sectionTop) {
					activeSection = section;
					break;
				}
			}

			// Retirer l'état actif de tous les éléments
			sections.forEach(section => {
				if (section.li) {
					section.li.classList.remove('is-active');
				}
			});

			// Ajouter l'état actif à la section courante
			if (activeSection && activeSection.li) {
				activeSection.li.classList.add('is-active');
			}
		};

		// Écouter le scroll
		window.addEventListener('scroll', updateActiveSection);
		updateActiveSection(); // Appel initial
	}
});

// Accordion
document.addEventListener('DOMContentLoaded', function () {
	const accordions = document.querySelectorAll('.lpm-accordion');

	accordions.forEach((accordion) => {
		const allowMultiple = accordion.getAttribute('data-allow-multiple') === 'true';
		const items = accordion.querySelectorAll('.lpm-accordion__item');
		const headers = accordion.querySelectorAll('.lpm-accordion__header');

		headers.forEach((header) => {
			header.addEventListener('click', function () {
				const item = this.closest('.lpm-accordion__item');
				const isOpen = item.classList.contains('is-open');
				const content = item.querySelector('.lpm-accordion__content');

				// Si on n'autorise pas plusieurs items ouverts, fermer les autres
				if (!allowMultiple && !isOpen) {
					items.forEach((otherItem) => {
						if (otherItem !== item) {
							otherItem.classList.remove('is-open');
							const otherContent = otherItem.querySelector('.lpm-accordion__content');
							const otherHeader = otherItem.querySelector('.lpm-accordion__header');
							if (otherContent) {
								otherContent.style.display = 'none';
							}
							if (otherHeader) {
								otherHeader.setAttribute('aria-expanded', 'false');
							}
						}
					});
				}

				// Toggle l'item actuel
				if (isOpen) {
					item.classList.remove('is-open');
					if (content) {
						content.style.display = 'none';
					}
					this.setAttribute('aria-expanded', 'false');
				} else {
					item.classList.add('is-open');
					if (content) {
						content.style.display = 'block';
					}
					this.setAttribute('aria-expanded', 'true');
				}
			});
		});
	});
});
